import BDImage from '@shared/components/elements/bd-image';
import BDButton from '@shared/components/elements/button';
import { BDStyledDialog } from '@shared/components/elements/dialog';
import DiamondIcon from '@shared/components/icons/diamond-icon';
import { DiamondVariant } from '@shared/lib/shopify/types/shopify-native';
import { renderMoney } from '@shared/lib/utils/money';
import { calculateDiamondImageSize } from '@shared/lib/utils/product-utils';
import Image, { StaticImageData } from 'next/image';
import { useActionState, useRef, useState } from 'react';
export default function FeaturedDiamond({
  name,
  ringName,
  image,
  variant,
  isFirstTimeOrder,
  formActionFunction,
  setSelectedVariant,
}: {
  name: string;
  ringName: string;
  image: StaticImageData;
  variant: DiamondVariant;
  isFirstTimeOrder: boolean;
  formActionFunction: (prevState: any, formData: any) => Promise<string | undefined>;
  setSelectedVariant: (variant: DiamondVariant) => void;
}) {
  const formRef = useRef<HTMLFormElement>(null);
  const [error, action, pending] = useActionState(formActionFunction, null);
  const imageSize = calculateDiamondImageSize(variant.carat, variant.shape, 0.25);
  const [galleryOpen, setGalleryOpen] = useState(false);
  return (
    <form key={name} className="flex flex-col gap-2" action={action} ref={formRef}>
      <div className="bg-bd-secondary aspect-square cursor-zoom-in rounded-lg border border-gray-200">
        <BDImage
          src={image}
          alt={name}
          className="h-full w-full rounded-lg object-cover"
          onClick={() => {
            setGalleryOpen(true);
          }}
        />
      </div>

      <BDStyledDialog
        openButton={null}
        open={galleryOpen}
        onClose={() => setGalleryOpen(false)}
        panelClassName="sm:!max-w-4xl"
        title={name}
        description={
          <>
            <p className="text-center text-sm font-normal sm:text-sm">On {ringName}</p>
            <p className="text-bd-dark/80 mt-auto text-center text-sm font-medium sm:text-sm">
              Diamond Only: {renderMoney(variant.price)}
            </p>
          </>
        }
        imageOrIcon={
          <div className="bg-bd-contrast flex h-20 w-20 items-center justify-center rounded-full">
            <DiamondIcon className="text-bd-dark h-full w-full p-5" />
          </div>
        }
      >
        <BDImage
          src={image}
          alt={name}
          className="mx-auto h-[70%] w-[70%] object-cover"
          onClick={() => {
            setGalleryOpen(true);
          }}
        />
        <section className="mt-4">
          <BDButton
            styleType="primary"
            className="relative mx-auto flex w-full items-center justify-center px-8 py-2 capitalize sm:w-auto"
            onClick={async (e) => {
              e.preventDefault();
              setSelectedVariant(variant);
              setGalleryOpen(false);
              // Wait for state update to be processed
              setTimeout(() => {
                formRef.current?.requestSubmit();
              }, 0);
            }}
            pending={pending}
            disabled={pending}
          >
            {isFirstTimeOrder ? 'Add to cart' : 'Add to cart'}
          </BDButton>
        </section>
      </BDStyledDialog>
      <div className="border-bd-secondary relative mx-auto flex aspect-square w-1/3 items-center justify-center rounded-lg border">
        <Image
          src={variant.image.url}
          alt={variant.image.altText || variant.title}
          width={variant.image.width}
          height={variant.image.height}
          style={{
            width: `${imageSize}em`,
            height: `${imageSize}em`,
          }}
          className="shadow-bd-dark drop-shadow-md"
        />
      </div>
      <p className="text-center text-sm md:text-base">{name}</p>
      <p className="text-bd-dark/80 text-center text-sm">On {ringName}</p>

      <p className="text-bd-dark/80 mt-auto text-center text-sm font-normal">
        Diamond Only: {renderMoney(variant.price)}
      </p>
      <BDButton
        styleType="secondary"
        className="relative flex w-full items-center justify-center px-8 py-2 capitalize sm:w-auto"
        onClick={async (e) => {
          e.preventDefault();
          setSelectedVariant(variant);
          // Wait for state update to be processed
          setTimeout(() => {
            formRef.current?.requestSubmit();
          }, 0);
        }}
        pending={pending}
        disabled={pending}
      >
        Add to cart
      </BDButton>
      {error && <p className="text-xxs text-red-500">{error}</p>}
    </form>
  );
}
